import { useState } from 'react';
import { useQuery } from 'react-query';
import groupBy from 'lodash.groupby';

import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
// icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/Add';

// app
import Layout from 'components/Layout';
import { Accordion, AccordionSummary, AccordionDetails } from 'components/CustomAccordion';
import { TranslateGroup } from 'components/TranslateGroup';
import appService from 'services/AppService';
import styles from './Translate.styles';
import { translateGroups } from 'config/const';

const NEW_TRANSLATION_KEY = '__new__';

const Translate = () => {
  const classes = makeStyles(styles, { name: 'Translate' })();
  const [addNew, setAddNew] = useState(null);
  const [expandedTypes, setExpandedTypes] = useState([]);
  // TODO fetch all
  const params = {
    size: 100,
  };
  const allLookups = useQuery(
    ['ALL_LOOKUPS'],
    async () => {
      const result = (await appService.getLookups(params)) || [];
      return result;
    },
    {
      onError: (err) => console.error(err),
      keepPreviousData: true,
    },
  );

  const { data } = allLookups;
  const lookups = data?.lookups?.data || [];

  const lookupsGroupedByType = groupBy(lookups, 'type');

  const sections = [
    ...translateGroups.map(({ type, name }) => ({
      type,
      name,
      lookups: lookupsGroupedByType[type] || [],
    })),
    ...Object.keys(lookupsGroupedByType)
      .filter((type) => !translateGroups.some((g) => g.type === type))
      .map((type) => ({
        type,
        name: type,
        lookups: lookupsGroupedByType[type],
      })),
  ];

  const handleAccordionChange = (type) => (_, isExpanded) => {
    setExpandedTypes((prev) => (isExpanded ? [...prev, type] : prev.filter((t) => t !== type)));
  };

  const handleAdd = (e, type) => {
    e.stopPropagation();
    setAddNew(type);
    setExpandedTypes((prev) => (prev.includes(type) ? prev : [...prev, type]));
  };

  const handleAddNew = (type) => {
    setAddNew(null);
  };

  return (
    <Layout>
      <Container maxWidth="lg" style={{ margin: 0 }}>
        <Grid container spacing={3} alignItems="flex-start">
          <Grid item xs={6}>
            <Box display="flex">
              <Typography variant="h4" as="h1">
                Translate
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Container className={classes.root} style={{ margin: 0 }}>
        {allLookups.isLoading ? <div>Loading...</div> : null}
        {allLookups.isError ? <div>Error</div> : null}
        {allLookups.isSuccess ? (
          <>
            {sections.map(({ type, name, lookups }) => (
              <Accordion
                elevation={4}
                key={type}
                expanded={expandedTypes.includes(type)}
                onChange={handleAccordionChange(type)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                  >
                    <Typography className={classes.heading}>{name}</Typography>
                    <IconButton onClick={(e) => handleAdd(e, type)}>
                      <AddIcon />
                    </IconButton>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <TranslateGroup
                    lookups={lookups}
                    addNew={addNew === type}
                    type={type}
                    handleAddNew={handleAddNew}
                  />
                </AccordionDetails>
              </Accordion>
            ))}
            <Accordion
              elevation={4}
              key={NEW_TRANSLATION_KEY}
              expanded={expandedTypes.includes(NEW_TRANSLATION_KEY)}
              onChange={handleAccordionChange(NEW_TRANSLATION_KEY)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="new-translation-content"
                id="new-translation-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                  <Typography className={classes.heading}>New Translation</Typography>
                  <IconButton onClick={(e) => handleAdd(e, NEW_TRANSLATION_KEY)}>
                    <AddIcon />
                  </IconButton>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <TranslateGroup
                  lookups={[]}
                  addNew={addNew === NEW_TRANSLATION_KEY}
                  showTypeField
                  handleAddNew={handleAddNew}
                />
              </AccordionDetails>
            </Accordion>
          </>
        ) : null}
      </Container>
    </Layout>
  );
};
export default Translate;
